module.exports = __webpack_public_path__ + "img/facebook.f6cf327d.png";